(function() {
  'use strict';

  angular
    .module('contentPlayer.slideViewerDirective', ['factories.mobileHelper'])
    .directive('mfSlideViewer', slideViewer);

  slideViewer.$inject = ['Navigation', 'MobileHelper', '$timeout', 'Sension', 'Utils'];

  function slideViewer(Navigation, MobileHelper, $timeout, Sension, Utils) {
    var directive = {
      link: link
    };

    return directive;

    function link(scope, elem) {
      var slide = elem.find('#slideOuter');
      var isTouch = MobileHelper.isTouch();
      var isMobileHeight = MobileHelper.isMobileHeight();
      var outer = $('#outer');
      outer.addClass('content-player');

      scope.navigation = Navigation;

      scope.$watch('navigation.state', function(state) {
        if (state !== Navigation.states.ready) {
          return;
        }

        slide.removeClass('slideContentLoading');
      });

      scope.onTap = function(e) {
        var playerControls;
        var show;

        if (!isTouch || !isMobileHeight) {
          return;
        }

        playerControls = scope.playerControls;
        if (!playerControls) {
          return;
        }

        // if on the media controls just keep the controls visible
        if ($(e.target).hasClass('mediaControlsWrapper') ||
          $(e.target).parents('.mediaControlsWrapper').length === 1) {
          togglePlayerControls(true);
          return;
        }

        if (ignoreSwipe(e)) {
          return;
        }

        show = !playerControls.headerControlsVisible;
        togglePlayerControls(show);
      };

      function togglePlayerControls(value, fadeTime) {
        var playerControls = scope.playerControls;
        if (!playerControls) {
          return;
        }

        $timeout(function() {
          playerControls.headerControlsVisible = value;
          if (playerControls.headerControlsVisible) {
            Utils.showStatusBar();
          } else {
            Utils.hideStatusBar();
          }

          if (Sension.enabled() && Sension.faceHidden()) {
            playerControls.slideControlsVisible = false;
          } else {
            playerControls.slideControlsVisible = value;
          }

          playerControls.resetControlsTimer(fadeTime);
        });
      }

      function ignoreSwipe(event) {
        return $(event.target).hasClass('noSwipe') ||
          $(event.target).parents('.noSwipe').length === 1;
      }

      scope.nextStep = function(event) {
        if (!isTouch || ignoreSwipe(event)) {
          return;
        }

        Navigation.navigateNext();
      };

      scope.previousStep = function(event) {
        if (!isTouch || ignoreSwipe(event)) {
          return;
        }

        Navigation.navigatePrevious();
      };

      scope.$on('$destroy', function() {
        slide.off();
        outer.removeClass('content-player');
      });
    }
  }
})();
